export default __webpack_public_path__ + "static/media/Staking Yellow.93fd6e72.png";